import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = createClient({
  projectId: 'fa41kzsv',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2024-01-01',
  token: process.env.REACT_APP_SANITY_TOKEN
})

const builder = imageUrlBuilder(client)

// Helper to build optimized image URLs
// Usage: urlFor(image).width(200).url()
export function urlFor(source) {
  return builder.image(source)
}
